export default __webpack_public_path__ + "static/media/edward.3c0f4b61.jpeg";